import {
    NumberDecimalPlaces,
    DisabledDecimalPlaces,
    StandardAdvancedSettings,
    AdvancedSettingsPanel
} from 'apps/studio/components/settings/fields/Base/advanced'


// all number
export const NumberAdvancedPanel = AdvancedSettingsPanel([
    NumberDecimalPlaces,
    ...StandardAdvancedSettings
])

export const CurrencyAdvancedPanel = AdvancedSettingsPanel([
    DisabledDecimalPlaces,
    ...StandardAdvancedSettings
])
